import Nft1 from '@/public/assets/nft/1.webp'
import Nft2 from '@/public/assets/nft/2.png'
import Nft3 from '@/public/assets/nft/3.png'
import Nft4 from '@/public/assets/nft/4.png'
import Nft5 from '@/public/assets/nft/5.png'

export const nftsImages = {
  '0': Nft1,
  '1': Nft2,
  '2': Nft3,
  '3': Nft4,
  '4': Nft5,
} as const
